module.exports = __webpack_public_path__ + "img/Floor002367-img4.3ac2afbc.jpg";